import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';
const initialData = {
  communicationTimeLineData: {},
  communicationTimeLineStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'communicationTimeLine',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getCommunicationTimeLineData: (state, action) => {
      state.communicationTimeLineData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.communicationTimeLineStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getCommunicationTimeLineData,
  fetchStart,
  fetchError,
  resetStatus,
} = slice.actions;

export const fetchCommunicationTimeLine = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`history/find/communicationtimeline/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCommunicationTimeLineData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};
export const resetStatusCode = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
